import { makeStyles } from '@material-ui/core/styles'
import { BREAKPOINTS, FONTS } from '../../constants'

export const styles = makeStyles(() => ({
  formControl: {
    width: '100%',
    minWidth: 110,
    maxWidth: 343,
    position: 'relative',
  },
  // Shown above BREAKPOINTS.sm; miniLabel shown below it (index.tsx renders both, CSS picks one)
  fullLabel: {
    [`@media (max-width: ${BREAKPOINTS.sm}px)`]: {
      display: 'none',
    },
  },
  miniLabel: {
    display: 'none',
    [`@media (max-width: ${BREAKPOINTS.sm}px)`]: {
      display: 'inline',
    },
  },
  selectList: {
    ['& > select']: {
      padding: 0,
      paddingLeft: 10,
      paddingRight: 0,
      backgroundColor: 'unset !important',
      fontFamily: FONTS.Graphik.GraphikRegular,
      fontSize: '0.75rem',
      lineHeight: 'normal',
      ['& > option']: {
        fontFamily: FONTS.Graphik.GraphikRegular,
      },
    },
  },
  sortByText: {
    paddingLeft: 20,
    paddingRight: 20,
    whiteSpace: 'nowrap',
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    fontFamily: FONTS.Graphik.GraphikRegular,
    fontSize: '0.75rem',
    fontWeight: 400,
    position: 'absolute',
    bottom: 7.5,
    left: 0,
    margin: 0,
    [`@media (max-width: ${BREAKPOINTS.sm}px)`]: {
      paddingLeft: 12,
      paddingRight: 8,
    },
  },
}))
